// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/recurring-journal-entries/create-recurring-journal-entry',
        component: () =>
            import('@/pages/[organisation]/accounting/recurring-journal-entries/create-recurring-journal-entry.vue'),
        name: 'accounting.recurring-journal-entries.create-recurring-journal-entry',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: 'access.accounting.general-ledger.create-recurring-journal-entry',
        },
    },
];
